import { get } from 'lodash'
import type { AxiosError } from 'axios'

export default function getAPIErrorMessage(
  err: AxiosError<any>,
  defaultErrorMsg = 'Error'
): string {
  return get(err, 'response.data.messages[0]', defaultErrorMsg)
}
